import React from "react";
import { Clock } from "lucide-react";
import { useAppSettings } from "@/lib/appSettings";

export const HomeTimezoneNotice = () => {
  const { loading, error, effective } = useAppSettings();
  if (loading || error || !effective.home_timezone_required) return null;
  return (
    <div role="status" data-testid="briefing-timezone-required" className="my-6 flex flex-wrap items-center gap-3 border-l-2 border-sky-600 bg-sky-50 p-4 text-sm text-sky-950">
      <Clock className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span data-testid="briefing-delivery-timing">Weekly delivery: around 6:00 a.m. on Thursdays.</span>
      <a href="#settings?section=home-timezone" data-testid="briefing-timezone-settings" className="font-semibold underline underline-offset-4 focus-visible:outline focus-visible:outline-2">
        Set your home timezone
      </a>
    </div>
  );
};